// extracted by mini-css-extract-plugin
export default {"componentWrapper":"OffersPeriodic_componentWrapper__I6EY6","header":"OffersPeriodic_header__uzYq8","searchFormWrapper":"OffersPeriodic_searchFormWrapper__R-0sh"};